import React, { useEffect } from "react";
import "./About.css";
import "../../global/main.css";
import { Element } from "react-scroll";
import image from "../../image/1Ysr-R03-0VI-Icon-أصلها ثابت-Vector-06.png";
import image1 from "../../image/1Ysr-R03-0VI-Icon-أصلها ثابت-Vectorأبيض-06.png";
import Asset2 from "../../image/1Ysr-001-VI-GuideLine less size (open this to view)_Page_11.jpg";
import iconslight2 from "../../image/icon/icon-02-light.png";
import icons2 from "../../image/icon/icon-02.png";
import iconslight4 from "../../image/icon/icon-04-light.png";
import icons4 from "../../image/icon/icon-04.png";
import iconslight5 from "../../image/icon/icon-05-light.png";
import icons5 from "../../image/icon/icon-05.png";
import iconslight6 from "../../image/icon/icon-06-light.png";
import icons6 from "../../image/icon/icon-06.png";
import iconslight7 from "../../image/icon/icon-07-light.png";
import icons7 from "../../image/icon/icon-07.png";
import "aos/dist/aos.css";
import Aos from "aos";

const About = (props) => {
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);

  return (
    <Element name="About">
      <section className="About">
        <div className="part1">
          <div className="about-left">
            <h2
              className="heading"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
            >
              من <span>نحن ؟</span>
            </h2>
            <p
              data-aos="fade-left"
              data-aos-duration="1500"
              data-aos-easing="ease-in-out"
            >
              اﻟﻴﺴﺮ ﻟﻼرﺗﻘﺎء اﻟﻌﻤﺮاﻧﻲ ﻫﻲ ﻣﺆﺳﺴﺔ ﺳﻮرﻳّﺔ ﺑﺪأت رﺣﻠﺘﻬﺎ ﻓﻲ اﻻرﺗﻘﺎء ﻣﻦ
              ﺧﻼل ﻛﻮادرﻫﺎ اﻟﺘﻲ ﺗﻤﺘﻠﻚ رؤﻳﺔ ﻟﻤﺴﺘﻘﺒﻞ اﻟﻌﻘﺎر اﻟﻌﻤﺮاﻧﻲ ﻋﺎم 2009
              و اﺳﺘﺜﻤﺎره ﺑﺎﻟﺸﻜﻞ اﻷﻓﻀﻞ ، وذﻟﻚ ﻣﻦ ﺧﻼل إدارة اﻟﻌﻤﻠﻴﺔ ﻛﺎﻣﻠﺔ ً ﻟﻠﻮﺻﻮل
              إﻟﻰ ﻋﻘﺎرات ﺗُﺆﻣّﻦ أﻋﻠﻰ ﻣﻌﺎﻳﻴﺮ اﻟﺠﻮدة واﻟﺮﻓﺎﻫﻴﺔ .
            </p>
            <div className="boxs">
              <div className="box" data-aos="fade-up" data-aos-duration="2000">
                <div className="box-header">
                  <label>رسالتنا</label>
                  <img src={props.trueDark ? image1 : image} alt="" />
                </div>
                <div className="box-body">
                  <p>
                    ﺗﺮاﺑُﻂ اﻟﻌﻤﻠﻴﺎت واﻷﻧﺸﻄﺔ ﻟﻼرﺗﻘﺎء اﻟﻌﻤﺮاﻧﻲ ﺿﻤﻦ ﻓﺘﺮة زﻣﻨﻴﺔ ٍ
                    وﻣﺎﻟﻴﺔ ٍ ﻣﻨﺎﻓﺴﺔ، ﻣﻊ ﺿﻤﺎن اﻟﺠﻮدة واﻟﺮﻓﺎﻫﻴﺔ.
                  </p>
                </div>
              </div>
              <div
                className="box"
                data-aos="fade-down"
                data-aos-duration="2000"
              >
                <div className="box-header">
                  <label>رؤﻳﺘﻨﺎ</label>
                  <img src={props.trueDark ? image1 : image} alt="" />
                </div>
                <div className="box-body">
                  <p>
                    ﻣُﺠﻤّﻌﺎت ﻋﻤﺮاﻧﻴﺔ ﺑﺄﻋﻠﻰ اﻟﻤﻌﺎﻳﻴﺮ ﻧﺤﻮ ﻧﻬﻀﺔ ٍ ﻋﻤﺮاﻧﻴﺔ اﺳﺘﺜﻤﺎرﻳﺔ
                    ٍ ﺣﻀﺎرﻳـّﺔ.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="content-image">
             
              <div
                className="content-text"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="2500"
              >
                <h3>. يداً بيد نحو الإرتقاء والعمران</h3>
              </div>
            </div> */}
          </div>
          <div className="about-right">
            <p>01</p>
            <span></span>
            <label>المقدمة</label>
          </div>
        </div>
        <div className={`part2 ${props.trueDark && "shadow"}`}>
          <div className="about-left">
            <div className="about-left-icon">
              <div
                data-aos="fade-right"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1000"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons2 : iconslight2}
                    alt="التكامل"
                  />
                </div>
                <p>التكامل</p>
              </div>
              <div
                data-aos="fade-right"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1500"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons7 : iconslight7}
                    alt="التسليم"
                  />
                </div>
                <p>التسليم</p>
              </div>
              <div
                data-aos="fade-left"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1000"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons4 : iconslight4}
                    alt="الجودة"
                  />
                </div>
                <p>الجودة</p>
              </div>
              <div
                data-aos="fade-left"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1500"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons2 : iconslight2}
                    alt="دقة التشييد"
                  />
                </div>
                <p>دقة التشييد</p>
              </div>
              <div
                data-aos="fade-right"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1000"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons6 : iconslight6}
                    alt="الشركات الاستراتيجية"
                  />
                </div>
                <p>الشركات الاستراتيجية</p>
              </div>
              <div
                data-aos="fade-right"
                data-aos-offset="150"
                data-aos-easing="ease-in-out"
                data-aos-duration="1500"
                className={`box-icon ${props.trueDark && "shadow"}`}
              >
                <div className="icon-wrapper">
                  <img
                    src={!props.trueDark ? icons5 : iconslight5}
                    alt="الرفاهية"
                  />
                </div>
                <p>الرفاهية</p>
              </div>
            </div>
            <div className="about-left-image"></div>
          </div>
          <div className="about-right">
            <p>02</p>
            <span></span>
            <label>لماذا اليسر ؟</label>
          </div>
        </div>
      </section>
    </Element>
  );
};

export default About;
